import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PDCoordinators from "../../PDCoordinators";

const FoundHerHero = () => {
  const navigate = useNavigate();
  const [showPDCoordinators, setShowPDCoordinators] = useState(false);
  const [showPrivateTeam, setShowPrivateTeam] = useState(false);
  const [showHustlers, setShowHustlers] = useState(false);

  return (
    <div className="relative min-h-[100dvh] flex flex-col items-center justify-center overflow-hidden px-4 bg-gradient-to-br from-rose-950 via-fuchsia-950 to-purple-950 text-white">
      {/* Soft Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(at_50%_25%,rgba(244,114,182,0.18),transparent_65%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_20%_80%,rgba(236,72,153,0.10),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_80%_70%,rgba(168,85,247,0.12),transparent_60%)]"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-6 py-2 rounded-full border border-white/20 mb-6">
          <span className="text-xl">💜</span>
          <span className="tracking-[0.25em] uppercase text-xs font-semibold text-rose-100">
            Think5Whys • PurpleDoor • FoundHer
          </span>
        </div>

        <h1 className="text-xl lg:text-3xl font-black tracking-tight leading-tight mb-2 bg-gradient-to-r from-white via-rose-100 to-pink-200 bg-clip-text text-transparent">
          Where Young Women
          <br />
          Become Founders
        </h1>
        <p className="text-lg lg:text-xl text-rose-100 font-medium mb-3">
          Find Her. Fund Her. Found Her.
        </p>
        <p className="max-w-3xl mx-auto text-xs lg:text-sm leading-relaxed text-rose-200/90 mb-2">
          Discover inspiring young women entrepreneurs, support their dreams,
          shop their products, mentor their journey, sponsor their ideas, and
          help build the next generation of purpose-driven businesses.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-1">
          <button
            onClick={() => navigate("/foundherjourney")}
            className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
          >
            🌱 Belief Journey
          </button>
          <button
            onClick={() => navigate("/foundherhome")}
            className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
          >
            🎯 Explore FoundHers →
          </button>
          <div className="flex flex-row gap-2">
            <button
              onClick={() => setShowPDCoordinators(!showPDCoordinators)}
              className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
            >
              🚀 Become a FoundHer
            </button>
            <button
              onClick={() => navigate("/foundher-support")}
              className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
            >
              🤝 Support a FoundHer
            </button>
          </div>
          <div className="flex flex-row gap-2">
            <button
              onClick={() => navigate("/foundhershg")}
              className="w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
            >
              👭 Create Private SHG/Team
            </button>
            <button
              onClick={() => navigate("/hustle")}
              className="w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
            >
              💼 Today's Hustlers Workforce
            </button>
          </div>
          <button
            onClick={() => navigate("/herkart")}
            className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
          >
            🌸 HerKart
          </button>
           <button
            onClick={() => navigate("/youthfounderacceleration")}
            className="w-fit lg:w-auto px-2 py-1 lg:py-1.5 rounded-xl text-xs lg:text-sm font-semibold bg-gradient-to-r from-pink-500 to-fuchsia-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-pink-500/30"
          >
            💜 Yuva Found(H)er Acceleration
          </button>
        </div>
        {showPDCoordinators && (
          <div className="mt-2">
            <PDCoordinators />
          </div>
        )}
      </div>

      {/* Floating Icons */}
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-8 text-2xl lg:text-3xl opacity-70">
        <div className="animate-bounce">👩‍💼</div>
        <div className="animate-bounce delay-150">💡</div>
        <div className="animate-bounce delay-300">🛍️</div>
        <div className="animate-bounce delay-[450ms]">🌸</div>
      </div>
    </div>
  );
};

export default FoundHerHero;